<template>
  <label
    class="checkbox"
    v-bind:class="{ any }"
  >
    <input
      class="checkbox__input"
      type="checkbox"
      v-bind:name="name"
      v-bind:checked="value"
      v-bind:disabled="disabled"
      v-on:change="onChange">
    <span class="checkbox__title">{{ title }}</span>
  </label>
</template>
<script>

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Компонент флажка.
 * @type {Vue}
 */
export default {
  methods: {
    /**
     * @description Обработать изменение.
     * @param {Event} event
     * @returns {void}
     */
    onChange(event) {
      this.$emit(NAME_EVENT_INPUT, event.target.checked);
    },
  },
  name: 'InputCheckbox',
  props: {
    /**
     * @description Любой выбор (промежуточный).
     */
    any: { default: () => false, type: Boolean },
    /**
     * @description Деактивирован.
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Заголовок.
     */
    title: { default: () => '', type: String },
    /**
     * @description Значение.
     */
    value: { required: true, type: Boolean },
    /**
     * @description Название поля.
     */
    name: { default: () => '', type: String },
  },
};
</script>
<style scoped>
.checkbox {
  width: fit-content;
}
.checkbox > .checkbox__input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.checkbox > .checkbox__title {
  align-items: center;
  display: inline-flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  user-select: none;
  cursor: pointer;
}
.checkbox > .checkbox__title::before {
  background-color: var(--primary-background-color);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 70%;
  border: 1px solid var(--unfocus-color);
  border-radius: 4px;
  content: '';
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  margin: 0 10px 0 0;
  width: 1.5rem;
}
.checkbox > .checkbox__input:not(:disabled, :checked) + .checkbox__title:hover::before {
  border-color: var(--action-color);
}
.checkbox > .checkbox__input:not(:disabled):active + .checkbox__title::before {
  background-color: var(--unfocus-color);
  border-color: var(--unfocus-color);
}
.checkbox > .checkbox__input:focus:not(:checked) + .checkbox__title::before {
  border-color: var(--unfocus-color);
}
.checkbox > .checkbox__input:checked + .checkbox__title::before,
.checkbox.any > .checkbox__input:not(:checked) + .checkbox__title::before {
  background-color: var(--action-color);
  border-color: var(--action-color);
}
.checkbox > .checkbox__input:checked + .checkbox__title::before {
  background-image: url("@/assets/img/checked/checked-white-top.svg");
}
.checkbox.any > .checkbox__input:not(:checked) + .checkbox__title::before {
  background-image: url("@/assets/img/minus.svg");
}
</style>
